<div class="panel-container report-scroll">
    <div class="panel-content">

    <!-- Score Type Radio Buttons -->
    <div class="score-type-toggle">
        <mat-radio-group [(ngModel)]="selectedScoreType" (ngModelChange)="onScoreTypeChanged($event)">
            <mat-radio-button [value]="scoreType.RISK_SCORE">Risk Score</mat-radio-button>
            <mat-radio-button [value]="scoreType.CONSOLIDATED_RISK_SCORE">Consolidated Risk Score</mat-radio-button>
        </mat-radio-group>
    </div>

    <!-- ========== RISK SCORE FORM ========== -->
    <form *ngIf="selectedScoreType === scoreType.RISK_SCORE" [formGroup]="colorizationForm" class="notif-fields-container">
        <!-- Indicator Selection -->
        <div class="notif-field">
            <label>Indicator: <span class="required-asterisk">*</span></label>
            <div class="display-flex column w-100 mT-4">
                <mat-select formControlName="indicator" placeholder="Choose an indicator" class="location-address-select">
                    <mat-option *ngFor="let indicator of climateIndicators" [value]="indicator.field">
                        {{ indicator.label }}
                    </mat-option>
                </mat-select>
                <div *ngIf="climateIndicators.length === 0" class="no-indicators-message">
                    No climatology overlays have been assigned to this dataset
                </div>
                <div *ngIf="colorizationForm.controls.indicator.touched && colorizationForm.controls.indicator.invalid" class="validation-error">
                    Indicator is required
                </div>
            </div>
        </div>

        <!-- Time Period Selection -->
        <div class="notif-field">
            <label>Time Period: <span class="required-asterisk">*</span></label>
            <div class="display-flex column w-100 mT-4">
                <mat-select formControlName="timePeriod" placeholder="Near Term" class="location-address-select">
                    <mat-option *ngFor="let period of timePeriods" [value]="period.value">
                        {{ period.label }}
                    </mat-option>
                </mat-select>
                <div *ngIf="colorizationForm.controls.timePeriod.touched && colorizationForm.controls.timePeriod.invalid" class="validation-error">
                    Time Period is required
                </div>
            </div>
        </div>

        <!-- Scenario SSP Selection -->
        <div class="notif-field">
            <label>Scenario SSP: 
                <span class="required-asterisk" *ngIf="colorizationForm.get('timePeriod').value !== TimePeriod.HISTORIC">*</span>
                <span *ngIf="colorizationForm.get('timePeriod').value === TimePeriod.HISTORIC" style="font-size: 11px; color: #999; font-style: italic;">(Not applicable for Historical)</span>
            </label>
            <div class="display-flex column w-100 mT-4">
                <mat-select formControlName="scenario" placeholder="SSP1-1.9" class="location-address-select">
                    <mat-option *ngFor="let scenario of scenarios" [value]="scenario.value">
                        {{ scenario.label }}
                    </mat-option>
                </mat-select>
                <div *ngIf="colorizationForm.controls.scenario.touched && colorizationForm.controls.scenario.invalid && colorizationForm.get('timePeriod').value !== TimePeriod.HISTORIC" class="validation-error">
                    Scenario SSP is required
                </div>
            </div>
        </div>

        <!-- Colorized By Field Selection -->
        <div class="notif-field">
            <label>Colorized By: <span class="required-asterisk">*</span></label>
            <div class="display-flex column w-100 mT-4">
                <mat-select formControlName="colorizationField" placeholder="Choose a field" class="location-address-select">
                    <!-- Only Risk Score option -->
                    <mat-option *ngFor="let option of specialColorOptions" 
                                [value]="option.value"
                                (click)="onSpecialOptionSelected(option.value)">
                        {{ option.label }}
                    </mat-option>
                </mat-select>
                <div *ngIf="colorizationForm.controls.colorizationField.touched && colorizationForm.controls.colorizationField.invalid" 
                     class="validation-error" 
                     style="color: #d32f2f; font-size: 12px; margin-top: 4px;">
                    Colorized By is required
                </div>
            </div>
        </div>

        <!-- Colorization Type Selection -->
        <div class="notif-field">
            <label>Colorization Type: <span class="required-asterisk">*</span></label>
            <div class="display-flex column w-100 mT-4">
                <mat-select formControlName="colorScaleType" 
                           (selectionChange)="onColorScaleTypeChanged($event.value)"
                           placeholder="Choose a colorization type" 
                           class="location-address-select">
                    <mat-option *ngFor="let type of scaleTypes" [value]="type">
                        {{ type }}
                    </mat-option>
                </mat-select>
                <div *ngIf="colorizationForm.controls.colorScaleType.touched && colorizationForm.controls.colorScaleType.invalid" 
                     class="validation-error"
                     style="color: #d32f2f; font-size: 12px; margin-top: 4px;">
                    Colorization Type is required
                </div>
            </div>
        </div>

        <!-- Constant Color (for CONSTANT type) -->
        <div class="notif-field" *ngIf="colorizationForm.value.colorScaleType === ColorScaleType.CONSTANT">
            <label>Color:</label>
            <div class="display-flex column w-100 mT-4">
                <div class="color-gradient-container">
                    <div class="color-picker-wrapper">
                        <span [style.background]="defaultColor"
                              [style.display]="'inline-block'"
                              [style.width]="'25px'"
                              [style.height]="'25px'"
                              [style.cursor]="'pointer'"
                              [style.border]="'1px solid rgba(0,0,0,0.2)'"
                              [style.border-radius]="'4px'"
                              [style.position]="'relative'"
                              (click)="colorInput1.click()">
                        </span>
                        <input #colorInput1 type="color"
                               class="hidden-color-input"
                               [value]="defaultColor"
                               (change)="onConstantColorChanged(colorInput1.value)">
                    </div>
                </div>
            </div>
        </div>

        <!-- Multiple Colors (always visible since only FIXED type is available) -->
        <div class="notif-field">
            <label>Colors:</label>
            <div class="display-flex column w-100 mT-4">
                <div class="color-gradient-container">
                    <ng-container *ngFor="let color of base64Colors; let i = index;">
                        <div class="color-square">
                            <span [style.background]="color"
                                  [style.display]="'inline-block'"
                                  [style.width]="'25px'"
                                  [style.height]="'25px'"
                                  [style.cursor]="'pointer'"
                                  [style.border]="'1px solid rgba(0,0,0,0.2)'"
                                  [style.border-radius]="'4px'"
                                  [style.position]="'relative'"
                                  (click)="openColorPicker(i)">
                            </span>
                            <input #colorInputs type="color"
                                   class="hidden-color-input"
                                   [value]="color"
                                   (change)="onColorChange($any($event.target).value, i)">
                            <span (click)="removeColor(i, $event)" class="remove-color-icon">
                                <mat-icon>remove</mat-icon>
                            </span>
                        </div>
                    </ng-container>
                    <span (click)="addColor()" class="add-color-icon">
                        <mat-icon style="position: relative !important;bottom: 7px !important; right: 7.5px !important;">add</mat-icon>
                    </span>
                </div>
            </div>
        </div>

        <!-- Interval Options (for INTERVAL type) -->
        <div class="notif-field" *ngIf="colorizationForm.value.colorScaleType === ColorScaleType.INTERVAL">
            <label>Custom Intervals: <span class="required-asterisk">*</span></label>
            <div class="display-flex column w-100 mT-4">
                <!-- Validation message when no intervals -->
                <div *ngIf="!dataset.climatologyStylingOptions.intervalOptions?.length" class="validation-error">
                    At least 1 interval must be defined. Use the form below to add intervals.
                </div>
                
                <!-- Display existing intervals -->
                <div *ngIf="dataset.climatologyStylingOptions.intervalOptions?.length" class="color-interval-content">
                    <div *ngFor="let interval of dataset.climatologyStylingOptions.intervalOptions; let index = index" class="color-interval-row">
                        <div class="color-square"
                             [ngStyle]="{'background': ColorUtils.colorToBase64(interval.color)}">
                        </div>
                        <div class="interval-range">[{{ (interval.minValue | number) || 'below' }}, {{ (interval.maxValue | number) || 'any' }}]</div>
                        <span *ngIf="index === dataset.climatologyStylingOptions.intervalOptions.length - 1" 
                              (click)="onRemoveColorInterval(index)" 
                              class="remove-color-interval" 
                              title="remove">
                            <mat-icon>remove</mat-icon>
                        </span>
                    </div>
                </div>
                
                <!-- Add new interval form -->
                <form [formGroup]="intervalForm" class="color-interval-row">
                    <div class="color-picker-wrapper">
                        <div class="color-square"
                             [style.background]="colorInterval"
                             (click)="intervalColorInput.click()">
                        </div>
                        <input #intervalColorInput 
                               type="color"
                               class="hidden-color-input"
                               [ngModel]="colorInterval"
                               [ngModelOptions]="{standalone: true}"
                               (ngModelChange)="onColorPickerIntervalChange($event)" />
                    </div>
                    <input formControlName="minValue" 
                           matInput 
                           placeholder="min" 
                           type="number" 
                           autocomplete="off">
                    <span>to</span>
                    <input formControlName="maxValue" 
                           matInput 
                           placeholder="max" 
                           type="number" 
                           autocomplete="off">
                    <span (click)="addInterval()" class="add-color-icon">
                        <mat-icon>add</mat-icon>
                    </span>
                </form>
            </div>
        </div>
    </form>

    <!-- ========== CONSOLIDATED RISK SCORE FORM ========== -->
    <form *ngIf="selectedScoreType === scoreType.CONSOLIDATED_RISK_SCORE" [formGroup]="colorizationForm" class="notif-fields-container">
        <!-- Vulnerability Profile Type Selection -->
        <div class="notif-field">
            <label>Vulnerability Profile Type: <span class="required-asterisk">*</span></label>
            <div class="display-flex column w-100 mT-4">
                <mat-select [(ngModel)]="selectedVulnerabilityProfile"
                            [ngModelOptions]="{standalone: true}"
                            placeholder="Choose a vulnerability profile type"
                            class="location-address-select">
                    <!-- Colorize by whichever profile type each location belongs to, rather than one -->
                    <mat-option [value]="allProfilesOption">{{ allProfilesLabel }}</mat-option>
                    <mat-option *ngFor="let profile of vulnerabilityProfiles" [value]="profile">
                        {{ profile.name }}
                    </mat-option>
                </mat-select>
            </div>
        </div>

        <!-- Time Period Selection -->
        <div class="notif-field">
            <label>Time Period: <span class="required-asterisk">*</span></label>
            <div class="display-flex column w-100 mT-4">
                <mat-select formControlName="timePeriod" placeholder="Near Term" class="location-address-select">
                    <mat-option *ngFor="let period of timePeriods" [value]="period.value">
                        {{ period.label }}
                    </mat-option>
                </mat-select>
                <div *ngIf="colorizationForm.controls.timePeriod.touched && colorizationForm.controls.timePeriod.invalid" class="validation-error">
                    Time Period is required
                </div>
            </div>
        </div>

        <!-- Scenario SSP Selection -->
        <div class="notif-field">
            <label>Scenario SSP: 
                <span class="required-asterisk" *ngIf="colorizationForm.get('timePeriod').value !== TimePeriod.HISTORIC">*</span>
                <span *ngIf="colorizationForm.get('timePeriod').value === TimePeriod.HISTORIC" style="font-size: 11px; color: #999; font-style: italic;">(Not applicable for Historical)</span>
            </label>
            <div class="display-flex column w-100 mT-4">
                <mat-select formControlName="scenario" placeholder="SSP1-1.9" class="location-address-select">
                    <mat-option *ngFor="let scenario of scenarios" [value]="scenario.value">
                        {{ scenario.label }}
                    </mat-option>
                </mat-select>
                <div *ngIf="colorizationForm.controls.scenario.touched && colorizationForm.controls.scenario.invalid && colorizationForm.get('timePeriod').value !== TimePeriod.HISTORIC" class="validation-error">
                    Scenario SSP is required
                </div>
            </div>
        </div>

        <!-- Colorization Type Selection -->
        <div class="notif-field">
            <label>Colorization Type: <span class="required-asterisk">*</span></label>
            <div class="display-flex column w-100 mT-4">
                <mat-select formControlName="colorScaleType" 
                           (selectionChange)="onColorScaleTypeChanged($event.value)"
                           placeholder="Choose a colorization type" 
                           class="location-address-select">
                    <mat-option *ngFor="let type of scaleTypes" [value]="type">
                        {{ type }}
                    </mat-option>
                </mat-select>
                <div *ngIf="colorizationForm.controls.colorScaleType.touched && colorizationForm.controls.colorScaleType.invalid" 
                     class="validation-error"
                     style="color: #d32f2f; font-size: 12px; margin-top: 4px;">
                    Colorization Type is required
                </div>
            </div>
        </div>

        <!-- Multiple Colors -->
        <div class="notif-field">
            <label>Colors:</label>
            <div class="display-flex column w-100 mT-4">
                <div class="color-gradient-container">
                    <ng-container *ngFor="let color of base64Colors; let i = index;">
                        <div class="color-square">
                            <span [style.background]="color"
                                  [style.display]="'inline-block'"
                                  [style.width]="'25px'"
                                  [style.height]="'25px'"
                                  [style.cursor]="'pointer'"
                                  [style.border]="'1px solid rgba(0,0,0,0.2)'"
                                  [style.border-radius]="'4px'"
                                  [style.position]="'relative'"
                                  (click)="openColorPicker(i)">
                            </span>
                            <input #colorInputs type="color"
                                   class="hidden-color-input"
                                   [value]="color"
                                   (change)="onColorChange($any($event.target).value, i)">
                            <span (click)="removeColor(i, $event)" class="remove-color-icon">
                                <mat-icon>remove</mat-icon>
                            </span>
                        </div>
                    </ng-container>
                    <span (click)="addColor()" class="add-color-icon">
                        <mat-icon style="position: relative !important;bottom: 7px !important; right: 7.5px !important;">add</mat-icon>
                    </span>
                </div>
            </div>
        </div>
    </form>

    </div>

    <div class="panel-footer">
        <button mat-stroked-button 
                (click)="onCancelAndReset()"
                type="button">
            Cancel
        </button>
        <button *ngIf="selectedScoreType === scoreType.RISK_SCORE" 
                mat-raised-button 
                color="primary" 
                (click)="onApply()"
                [disabled]="!colorizationForm.valid"
                type="button">
            Apply
        </button>
        <button *ngIf="selectedScoreType === scoreType.CONSOLIDATED_RISK_SCORE" 
                mat-raised-button 
                color="primary" 
                (click)="onConsolidatedApply()"
                type="button">
            Apply
        </button>
    </div>
</div>
